import { useTranslation } from 'react-i18next';
import { Sheet } from '../common/Sheet';

interface TeamPickerProps {
    // The league's team abbreviations, in display order.
    teams: readonly string[];
    enabled: boolean;
    selected: readonly string[];
    onEnabledChange(enabled: boolean): void;
    onSelectedChange(selected: string[]): void;
    onClose(): void;
}

// The hidden-teams picker: an on/off switch (which keeps the list when off) and
// the league's teams. Games of a hidden team show as one line until "show" is pressed.
export function TeamPicker({ teams, enabled, selected, onEnabledChange, onSelectedChange, onClose }: TeamPickerProps) {
    const { t } = useTranslation();

    const toggleTeam = (abbrev: string) => {
        const isSelected = selected.includes(abbrev);
        if (!isSelected && !enabled && selected.length === 0) {
            // The first pick means the user wants hiding on.
            onEnabledChange(true);
        }
        onSelectedChange(isSelected ? selected.filter(team => team !== abbrev) : [...selected, abbrev]);
    };

    return (
        <Sheet title={t('hide_button')} doneLabel={t('common_done')} onClose={onClose}>
            <div className="switch-row">
                <span id="hide-enabled-label">{t('hide_enabled')}</span>
                <button
                    type="button"
                    role="switch"
                    aria-checked={enabled}
                    aria-labelledby="hide-enabled-label"
                    className="switch"
                    onClick={() => onEnabledChange(!enabled)}
                />
            </div>
            <div className="team-grid">
                {teams.map(abbrev => (
                    <button
                        key={abbrev}
                        type="button"
                        aria-pressed={selected.includes(abbrev)}
                        className={selected.includes(abbrev) ? 'off' : undefined}
                        onClick={() => toggleTeam(abbrev)}
                    >
                        {abbrev}
                    </button>
                ))}
            </div>
        </Sheet>
    );
}
